'use strict';

const maxVideoCount = 3;

export default class IntroVideosCtrl {
  constructor($stateParams, videos, slideshow, shuffle) {
    'ngInject';

    this.slideshow = slideshow;
    this.currentIndex = 0;

    const placeId = $stateParams.placeId;
    if (placeId) {
      this.videos = videos
        .filter((video) => video.placeId === placeId)
        .concat(videos.filter((video) => video.placeId !== placeId));
    } else {
      this.videos = shuffle(videos);
    }

    this.videos = this.videos.slice(0, maxVideoCount);
  }

  playVideo() {
    this.slideshow.show([
      this.videos[this.currentIndex]
    ], 0, { isCounterVisible: false });
  }

  showPage(pageIndex) {
    var videoCount = this.videos.length;
    this.currentIndex = (pageIndex % videoCount + videoCount) % videoCount;
  }

  showNext() {
    this.showPage(this.currentIndex + 1);
  }

  showPrevious() {
    this.showPage(this.currentIndex - 1);
  }
}



// WEBPACK FOOTER //
// ./app/src/common/intro_videos/intro_videos.js